import { TMessage, TMessageSchema } from '../../types/messages';

/**
 * Обновляет общие поля сообщения из rawMessage
 */
export function mapCommonMessageFields(rawMessage: TMessageSchema, existingMessage: TMessage): TMessage {
  return {
    ...existingMessage,
    actionButtons: rawMessage.actionButtons,
    actionButtonsV3: rawMessage.actionButtonsV3,
    bubbles: rawMessage.bubbles,
    htmlText: rawMessage.htmlText,
    message: rawMessage.text || existingMessage.message,
    offers: rawMessage?.offers || [],
    rowVersion: rawMessage?.rowVersionV2 || rawMessage?.rowVersion,
    assumptions: rawMessage?.assumptions,
    files: rawMessage?.files,
    images: rawMessage?.images,
    created: new Date(rawMessage.created).getTime(),
  };
}
